import { useListEligibilityCategoriesQuery } from "@/data/queries/eligibilityCategoriesQueries";
import { composeBrandLabel, getProgramTypeLabel } from "@/utils/brandLabel";

import { usePatientUSState } from "./usePatientUSState";

/**
 * Returns the Marketplace brand label for the current patient's US state.
 * Since there's only one Marketplace brand name per state, this always resolves
 * the correct state-specific name (e.g. "NY State of Health") regardless of
 * whether any household member is eligible for Marketplace.
 */
export const useMarketplaceBrandLabel = (): string => {
  const usState = usePatientUSState();

  const { data: categories } = useListEligibilityCategoriesQuery({
    filters: { usState },
    enabled: Boolean(usState),
  });

  const marketplaceCategories =
    categories?.filter(c => c.applicationType === "MARKETPLACE") ?? [];

  if (marketplaceCategories.length === 0) {
    return getProgramTypeLabel("MARKETPLACE");
  }

  return composeBrandLabel(marketplaceCategories, "MARKETPLACE");
};
